import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion';

export const FAQ = () => {
  const faqs = [
    {
      question: 'Was kostet die Vermittlung einer Handelsimmobilie?',
      answer:
        'Die Provision richtet sich nach dem Verkaufspreis und wird individuell vereinbart. In einem ersten Gespräch klären wir transparent alle Kosten und Leistungen.',
    },
    {
      question: 'Wie lange dauert der Verkauf einer Handelsimmobilie?',
      answer:
        'Die Verkaufsdauer hängt von vielen Faktoren ab: Objektqualität, Mietvertragssituation, Standort und Marktlage. In der Regel sollten Sie mit 6-12 Monaten rechnen. Gut vorbereitete Objekte können schneller verkauft werden.',
    },
    {
      question: 'Welche Unterlagen benötige ich für einen Verkauf?',
      answer:
        'Für eine erfolgreiche Vermarktung benötigen Sie: Mietverträge inkl. Nachträge, Grundbuchauszug, Flächenpläne, Betriebskostenabrechnungen der letzten 3 Jahre, Energieausweis und ggf. Baugenehmigungen. Wir erstellen mit Ihnen eine vollständige Checkliste.',
    },
    {
      question: 'Was ist der WAULT und warum ist er wichtig?',
      answer:
        'WAULT (Weighted Average Unexpired Lease Term) ist die gewichtete durchschnittliche Restlaufzeit aller Mietverträge. Käufer nutzen diese Kennzahl zur Risikobewertung. Ein höherer WAULT bedeutet längere Planungssicherheit und meist bessere Verkaufspreise.',
    },
    {
      question: 'Muss ich die Mieter über den Verkauf informieren?',
      answer:
        'Ja, Mieter haben ein gesetzliches Vorkaufsrecht. Wir begleiten Sie bei der korrekten und zeitgerechten Information der Mieter und stellen sicher, dass alle rechtlichen Anforderungen erfüllt werden.',
    },
    {
      question: 'Können Sie auch bei komplizierten Mietverhältnissen helfen?',
      answer:
        'Ja, gerade bei komplexen Mietvertragssituationen ist professionelle Begleitung wichtig. Wir analysieren die Situation, identifizieren mögliche Risiken und entwickeln eine passende Verkaufsstrategie – auch bei auslaufenden Verträgen oder Leerständen.',
    },
  ];

  return (
    <section className="py-20 bg-white" data-testid="faq-section">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2
            className="text-3xl md:text-4xl font-semibold mb-4"
            style={{ color: 'var(--primary-800)' }}
          >
            Häufig gestellte Fragen
          </h2>
          <p className="text-lg" style={{ color: 'var(--secondary-600)' }}>
            Antworten auf die wichtigsten Fragen zum Verkauf von Handelsimmobilien
          </p>
        </div>

        <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
          {faqs.map((faq, index) => (
            <AccordionItem key={index} value={`item-${index}`}>
              <AccordionTrigger
                className="text-left font-semibold"
                style={{ color: 'var(--primary-700)' }}
                data-testid={`faq-question-${index}`}
              >
                {faq.question}
              </AccordionTrigger>
              <AccordionContent
                className="text-sm"
                style={{ color: 'var(--secondary-600)' }}
                data-testid={`faq-answer-${index}`}
              >
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};